export const CancelType: {
    [key: string]: string;
} = {
    // Cancelled
    25100: 'Delivery outside radius',
    25101: 'Area too dangerous',
    25102: 'Customer cancelled',
    25103: 'Restaurant/retailer cancelled',
    25104: 'Outside delivery hours',
    25106: 'Driver could not return the items (specify in comment)',
    25199: 'Cancelled, other (specify in comment)',

    // Failed
    25200: 'No answer from customer',
    25201: 'Incorrect address provided',
    25202: 'Driver safety issue',
    25203: 'Fake order',
    25204: 'Customer has no cash for cash order',
    25299: 'Failed, other (specify in comment)'
};
